
export const E404 = ({ children }) =>
    <p className="p-5">404-not found <br />{children}</p>